module.exports = __webpack_public_path__ + "static/media/pre_purchase.e0af977f.png";